/**
* Tabbed Benefits JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed Benefits component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-benefits',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '#tabbed-benefits__slick' ).slick( {
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: false,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
      } );

      let percentTime;
      let tick;
      const time = 1;
      let progressBarIndex = 0;

      $( '.progressBar' ).each( function( index ) {
        const progress = '<div class=\'inProgress inProgress' + index + '\'></div>';
        $( this ).html( progress );
      } );

      function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        tick = setInterval( interval, 10 );
      }

      function interval() {
        if ( ( $( '#tabbed-benefits__slick .slick-track div[data-slick-index="' + progressBarIndex + '"]' ).attr( 'aria-hidden' ) ) === 'true' ) {
          progressBarIndex = $( '#tabbed-benefits__slick .slick-track div[aria-hidden="false"]' ).data( 'slickIndex' );
          startProgressbar();
        } else {
          percentTime += 1 / ( time + 5 );
          $( '.inProgress' + progressBarIndex ).css( {
            width: percentTime + '%',
          } );
          $( '.tab-button-' + progressBarIndex ).addClass( 'active' );
          if ( percentTime >= 100 ) {
            $( '#tabbed-benefits__slick' ).slick( 'slickNext' );
            progressBarIndex++;
            if ( progressBarIndex > 2 ) {
              progressBarIndex = 0;
            }
            startProgressbar();
          }
        }
      }

      function resetProgressbar() {
        $( '.inProgress' ).css( {
          width: 0 + '%',
        } );
        $( '.tabs-wrapper button' ).removeClass( 'active' );
        clearInterval( tick );
      }
      startProgressbar();

      $( 'button' ).on( 'click', function() {
        clearInterval( tick );
        const goToThisIndex = $( this ).find( 'span' ).data( 'slickIndex' );
        $( '#tabbed-benefits__slick' ).slick( 'slickGoTo', goToThisIndex, false );
        startProgressbar();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-benefits', COMPONENT );
} )( app );
